"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventTypes = _interopRequireDefault(require("../../enum/EventTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * request auto track
 * @param {*} scout 
 */
function init(scout) {
  var NativeXHR = XMLHttpRequest;

  window.XMLHttpRequest = function NewXHR() {
    var xhr = new NativeXHR();
    xhr.addEventListener('loadend', handleLoadEnd);
    return xhr;

    function handleLoadEnd() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          var response = JSON.parse(xhr.responseText);
          scout.track(_EventTypes["default"].REQUEST, {
            code: response.code,
            message: response.message,
            url: xhr.responseURL
          });
        } catch (e) {}
      }
    }
  };
}

var _default = {
  init: init,
  name: 'request'
};
exports["default"] = _default;